import Vue from 'vue';
import Vuex from 'vuex';
import i18n from "./i18n";
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        // APP显示状态相关
        primaryDrawer: true,
        fullscreenLoading: false,
        fullscreenImages: null,
        printPageSize: "",
        printFontSize: i18n.t("$print.defaultFontSizeOptions"),
        supportBrowser: 0,
        stickTableCols: false,
        mainContentScrolled: 0,
        fixHeaderHeightInPx: 70,
        printMode: false,
        fullscreenMode: false,
        dashBoardMode: false,
        loading: false,
        loadingThread: 0,
        showSearchPanel: localStorage.getItem("showSearchPanel") == "true",
        showSparklinePanel: localStorage.getItem("showSparklinePanel") == "true",
        refreshToDos: false,
        // 账号相关
        accessToken: "",
        accountInfo: null,
        accountUser: null,
        allow: null,
        settings: null,
        // sync_base_data_from: 0,
        sync_material_data_from: 0,
        sync_supplier_data_from: 0,
        sync_shop_data_from: 0,
        permission_districts: null,
        permission_stocks: null,
        net_units: [], //净含量可用的单位数组
        // 分组树相关
        serverDistricts: [],
        navName: sessionStorage.getItem("navName"),
        searchDistrict: true,
        districtID: 0,
        citiesMap: [],
        citiesMapTime: 0,
        // 待办数量提醒
        todos: {},
        toreads: 0,
        unReadNotice: 0,
        cloudPrintPageSize: "",
        subAccountEditStatus: {},
        materialCountMax:1500,//选择商品弹窗超过这个数量，一打开不加载，搜索时加载
    },
    mutations: {
        LOGIN(state, accessToken) {
            localStorage.setItem("accessToken", accessToken);
            state.accessToken = accessToken;
        },
        USERINFO(state, data) {
            state.accountUser = data.account_user;
            state.accountInfo = data.account_info;
            state.allow = data.allow;
            state.toreads = data.alerts_count;
            state.settings = data.settings;
            if (data.settings && data.settings.logo_url) {
                localStorage.setItem("logo_url", data.settings.logo_url);
            } else {
                localStorage.removeItem("logo_url");
            }
            state.permission_districts = data.permission_districts;
            state.permission_stocks = data.permission_stocks;
            if (data.settings && data.settings.push_platform_setting && data.settings.push_platform_setting != 'null' ) {
                if ('2101' in data.settings.push_platform_setting ) {
                    // if (data.settings.push_platform_setting[2101].sync_base_data_from) {
                    //      state.sync_base_data_from = data.settings.push_platform_setting[2101].sync_base_data_from;
                    // }
                    if (data.settings.push_platform_setting[2101].sync_material_data_from) { 
                        state.sync_material_data_from = data.settings.push_platform_setting[2101].sync_material_data_from;
                    }
                    if (data.settings.push_platform_setting[2101].sync_supplier_data_from) { 
                        state.sync_supplier_data_from = data.settings.push_platform_setting[2101].sync_supplier_data_from;
                    }
                    if (data.settings.push_platform_setting[2101].sync_shop_data_from) { 
                        state.sync_shop_data_from = data.settings.push_platform_setting[2101].sync_shop_data_from;
                   }
                   
                }
            }
        },
        NET_UNITS(state, data) {
            state.net_units = data;
        },
        LOGOUT(state) {
            state.accessToken = "";
            localStorage.setItem("accessToken", "");
            //清理会话存储
            sessionStorage.clear();
            //清理账号相关的状态
            state.accountInfo = null;
            state.accountUser = null;
            state.allow = null;
            state.toreads = 0;
            state.searchDistrict = false;
            state.districtID = 0;
            //重新加载页面
            var url = window.location.href;
            var arrUrl = url.split("//");
            var start = arrUrl[1].indexOf("/");
            window.open(arrUrl[0] + "//" + arrUrl[1].substring(0, start), "_self");
        },
        stickTableCols(state, sticky) {
            state.stickTableCols = sticky;
        },
        mainContentScrolled(state, top) {
            state.mainContentScrolled = top;
        },
        fixHeaderHeightInPx(state, height) {
            state.fixHeaderHeightInPx = height;
        },
        fullscreenLoading(state, loading) {
            state.fullscreenLoading = loading;
        },
        printPageSize(state, printPageSize) {
            state.printPageSize = printPageSize;
        },
        printFontSize(state, printFontSize) {
            state.printFontSize = printFontSize;
        },
        cloudPrintPageSize(state, cloudPrintPageSize) {
            state.cloudPrintPageSize = cloudPrintPageSize;
        },
        supportBrowser(state, supportBrowser) {
            state.supportBrowser = supportBrowser;
        },
        printMode(state, printMode) {
            state.printMode = printMode;
        },
        fullscreenMode(state, fullscreenMode) {
            state.fullscreenMode = fullscreenMode;
        },
        dashBoardMode(state, dashBoardMode) {
            state.dashBoardMode = dashBoardMode;
        },
        primaryDrawer(state, open) {
            state.primaryDrawer = open;
        },
        fullscreenImages(state, imgs) {
            state.fullscreenImages = imgs;
        },
        threadLoading(state, loading) {
            if (loading) {
                state.loadingThread++;
                state.loading = true;
            } else {
                state.loadingThread--;
                if (state.loadingThread <= 0) {
                    state.loadingThread = 0;
                    state.loading = false;
                }
            }
        },
        threadLoadingStopAll(state) {
            state.loadingThread = 0;
            state.loading = false;
        },
        refreshToDos(state, refreshToDos) {
            state.refreshToDos = refreshToDos;
        },
        serverDistricts(state, serverDistricts) {
            state.serverDistricts = serverDistricts;
        },
        navName(state, navName) {
            state.navName = navName;
            sessionStorage.setItem("navName", state.navName);
        },
        searchDistrict(state, show) {
            state.searchDistrict = show;
        },
        districtID(state, districtID) {
            state.districtID = districtID;
        },
        toggleSearchPanel(state) {
            state.showSearchPanel = !state.showSearchPanel;
            localStorage.setItem("showSearchPanel", state.showSearchPanel);
        },
        openSearchPanel(state) {
            state.showSearchPanel = true;
            localStorage.setItem("showSearchPanel", state.showSearchPanel);
        },
        closeSearchPanel(state) {
            state.showSearchPanel = false;
            localStorage.setItem("showSearchPanel", state.showSearchPanel);
        },
        toggleSparkline(state) {
            state.showSparklinePanel = !state.showSparklinePanel;
            localStorage.setItem("showSparklinePanel", state.showSparklinePanel);
        },
        citiesMap(state, citiesMap) {
            state.citiesMap = citiesMap;
            state.citiesMapTime = new Date().getTime();
        },
        todos(state, todos) {
            state.todos = todos;
        },
        unReadNotice(state, count) {
            state.unReadNotice = count;
        },
        subAccountEditStatus(state, subAccountEditStatus) {
            state.subAccountEditStatus = subAccountEditStatus;
        },
    },
    getters: {
        panels: state => {
            return [
                state.showSearchPanel ? 0 : null,
                state.showSparklinePanel ? 1 : null
            ]
        }
    },
    actions: {
        fullscreenLoading(context) {
            context.commit('fullscreenLoading', true);
        },
        fullscreenLoadingStop(context) {
            context.commit('fullscreenLoading', false);
        },
        threadLoadingStart(context) {
            context.commit('threadLoading', true);
        },
        threadLoadingStop(context) {
            context.commit('threadLoading', false);
        },
        threadLoadingStopAll(context) {
            context.commit('threadLoadingStopAll');
        },
    }
})

export default store;